'use client';
import React from 'react';
import ProductCarousel from '@/components/ui/ProductCarousel';
import { ProductBase } from '@/types/product';
import { BreadcrumbMenu } from '@/types/menu';

interface RelatedProductsSectionProps {
  breadcrumbMenu: BreadcrumbMenu;
  onFavoriteToggle?: (id: string) => void;
  relatedProducts: ProductBase[];
}

const RelatedProductsSection: React.FC<RelatedProductsSectionProps> = ({
  breadcrumbMenu,
  onFavoriteToggle,
  relatedProducts
}) => {
  return (
    <div data-component-id="src/components/sections/RelatedProductsSection.tsx:19:4" data-component-path="src/components/sections/RelatedProductsSection.tsx" data-component-line="19" data-component-file="RelatedProductsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22py-12%22%7D" className="py-12">
      <div data-component-id="src/components/sections/RelatedProductsSection.tsx:20:6" data-component-path="src/components/sections/RelatedProductsSection.tsx" data-component-line="20" data-component-file="RelatedProductsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mb-2%20text-left%22%7D" className="mb-2 text-left">
        <p data-component-id="src/components/sections/RelatedProductsSection.tsx:21:8" data-component-path="src/components/sections/RelatedProductsSection.tsx" data-component-line="21" data-component-file="RelatedProductsSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-global-1%20text-%5B40px%5D%20leading-%5B48px%5D%20mb-1%22%2C%22textContent%22%3A%22QUIZ%C3%81%20TAMBI%C3%89N%20TE%20GUSTE...%22%7D"
          className="text-global-1 text-[40px] leading-[48px] mb-1"
          style={{
            fontFamily: "'TT_Norms_Pro-Extra-Black', Helvetica",
            fontWeight: '900',
          }}
        >
          QUIZÁ TAMBIÉN TE GUSTE...
        </p>
        <div data-component-id="src/components/sections/RelatedProductsSection.tsx:30:8" data-component-path="src/components/sections/RelatedProductsSection.tsx" data-component-line="30" data-component-file="RelatedProductsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-global-9%20rounded-none%20px-4%20w-fit%20mb-6%22%7D" className="bg-global-9 rounded-none px-4 w-fit mb-6">
          <span data-component-id="src/components/sections/RelatedProductsSection.tsx:31:10" data-component-path="src/components/sections/RelatedProductsSection.tsx" data-component-line="31" data-component-file="RelatedProductsSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-global-1%20text-%5B22px%5D%20leading-%5B27px%5D%22%2C%22textContent%22%3A%22Seguro%20que%20te%20interesa%22%7D" 
            className="text-global-1 text-[22px] leading-[27px]"
            style={{
              fontFamily: "'TT_Norms_Pro-Regular', Helvetica",
              fontWeight: '400'
            }}
          >
            Seguro que te interesa
          </span>
        </div>
        <ProductCarousel data-component-id="src/components/sections/RelatedProductsSection.tsx:41:8" data-component-path="src/components/sections/RelatedProductsSection.tsx" data-component-line="41" data-component-file="RelatedProductsSection.tsx" data-component-name="ProductCarousel" data-component-content="%7B%22elementName%22%3A%22ProductCarousel%22%2C%22className%22%3A%22mb-8%22%7D"
          breadcrumbMenu={breadcrumbMenu}
          items={relatedProducts}
          className="mb-8"
          onFavoriteToggle={onFavoriteToggle}
          defaultVisibleCount={5}
          showNavigation={true}
          productTitleAsParagraph
        />
      </div>
    </div>
  );
};

export default RelatedProductsSection; 